<template>
  <OverlayCard width="m" @cancel="$emit('cancel')">
    <template #title>
      {{ $t('loginExpiredCard.text.title') }}
    </template>

    <template #content>
      <div v-html="$t('loginExpiredCard.text.main')"></div>
    </template>

    <template #footer>
      <Btn color="blue" size="medium" @click="redirectToLogin">
        {{ $t('loginExpiredCard.action') }}
      </Btn>
    </template>
  </OverlayCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  emits: { cancel: null },
  name: 'LoginExpiredCard',
  methods: {
    redirectToLogin() {
      this.$auth.loginWithRedirect({
        appState: {
          targetUrl: this.$route.fullPath,
        },
      });
    },
  },
});
</script>
